import React from "react";
import { connect } from "react-redux";
import Header from "../../../components/Header";
import Firebase from "../../../firebasehelper";
import { pagesBySection, titles } from "../../../Constants/selections";
import "./index.css";

const TokenOffer = require("../../../assets/media/community_tabs/token-offers.png");
const DiscountOffer = require("../../../assets/media/community_tabs/discount.png");
const EarnTokens = require("../../../assets/media/community_tabs/chip.png");
const Community = require("../../../assets/media/community_tabs/connection.png");
const MyProfile = require("../../../assets/media/community_tabs/security.png");
const Forum = require("../../../assets/media/community_tabs/forum.png");
const Polls = require("../../../assets/media/community_tabs/opinion.png");
const Shop = require("../../../assets/media/community_tabs/shop.png");
const Ecopay = require("../../../assets/media/community_tabs/pay.png");
const Friends = require("../../../assets/media/community_tabs/eco-friendly.png");
const Wallet = require("../../../assets/media/community_tabs/wallet.jpg");
const Timeline = require("../../../assets/media/community_tabs/timeline.png");
const Support = require("../../../assets/media/community_tabs/support.png");
const Ecosystem = require("../../../assets/media/community_tabs/ecosystem.png");
const TokenPay = require("../../../assets/media/community_tabs/tokenPay.png");
const Events = require("../../../assets/media/community_tabs/event.png");
const Reviews = require("../../../assets/media/community_tabs/review.png");
const Saving = require("../../../assets/media/community_tabs/saving.png");
const Genius = require("../../../assets/media/DeveloperIntegration/Plugins/genius.png");
const iPhoneBorder = require("../../../assets/media/DeveloperIntegration/iFrame/iphone-border.png");
const tokenWallet = require("../../../assets/media/community_tabs/token_wallet.png");
const cardWallet = require("../../../assets/media/community_tabs/wallet.jpg");
const bankingWallet = require("../../../assets/media/community_tabs/pay.png");

const images = {
  explore: Ecosystem,
  support: Support,
  tokenPay: TokenPay,
  feeds: Forum,
  polls: Polls,
  friends: Friends,
  community: Community,
  events: Events,
  reviews: Reviews,
  tokenwallet: tokenWallet,
  cardwallet: cardWallet,
  bankwallet: bankingWallet,
  ecopay: Ecopay,
  tokenOffers: TokenOffer,
  discountOffers: DiscountOffer,
  earnTokens: EarnTokens,
  shop: Shop,
  saving: Saving,
  myId: MyProfile,
  timeline: Timeline,
  task_subsite: Ecosystem,
  task_submission: Ecosystem,
};
class Plugins extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      plugins: {
        explore: true,
        support: true,
        tokenPay: true,
        feeds: true,
        polls: true,
        friends: true,
        community: false,
        events: false,
        reviews: false,
        wallet: true,
        ecopay: true,
        tokenOffers: true,
        discountOffers: false,
        earnTokens: true,
        shop: true,
        saving: true,
        myId: true,
        timeline: true,
        task_subsite: true,
        task_submission: true,
      },
      brand_name: "",
      demoUser: null,
      iframeURL: "",
    };
  }
  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
      if (this.props.brand) {
        this.loadState(this.props.brand);
      } else
        Firebase.getBrandDataByID(brand, (res) => {
          this.loadState(res);
        });
    }
  }
  loadState = async (brand_data) => {
    console.log("brand_data", brand_data);
    let users = await Firebase.getAllUsersInBrand(brand_data.name);
    const demoUser = users.find((obj) => obj.isDemo);
    this.setState({
      iframeURL: demoUser
        ? `https://ecosystem.life/${brand_data.name.replace(
            /\s/g,
            ""
          )}?page=explore&uid=${demoUser.id}`
        : "",
      demoUser: demoUser,
      logo: brand_data.logo,
      icon: brand_data.icon,
      brand_name: brand_data.name,
      brand_url: brand_data.url,
      hex: brand_data.hex,
      umbrella: brand_data.umbrella,
      is_property_brand: brand_data.is_property_brand,
      plugins: brand_data.plugins
        ? {
            explore:
              brand_data.plugins.explore === undefined
                ? true
                : brand_data.plugins.explore,
            support:
              brand_data.plugins.support === undefined
                ? true
                : brand_data.plugins.support,
            tokenPay:
              brand_data.plugins.tokenPay === undefined
                ? true
                : brand_data.plugins.tokenPay,
            feeds:
              brand_data.plugins.feeds === undefined
                ? true
                : brand_data.plugins.feeds,
            polls:
              brand_data.plugins.polls === undefined
                ? true
                : brand_data.plugins.polls,
            friends:
              brand_data.plugins.friends === undefined
                ? true
                : brand_data.plugins.friends,
            community:
              brand_data.plugins.community === undefined
                ? false
                : brand_data.plugins.community,
            events:
              brand_data.plugins.events === undefined
                ? false
                : brand_data.plugins.events,
            reviews:
              brand_data.plugins.reviews === undefined
                ? false
                : brand_data.plugins.reviews,
            tokenwallet:
              brand_data.plugins.tokenwallet === undefined
                ? true
                : brand_data.plugins.tokenwallet,
            cardwallet:
              brand_data.plugins.cardwallet === undefined
                ? true
                : brand_data.plugins.cardwallet,
            bankwallet:
              brand_data.plugins.bankwallet === undefined
                ? true
                : brand_data.plugins.bankwallet,
            ecopay:
              brand_data.plugins.ecopay === undefined
                ? true
                : brand_data.plugins.ecopay,
            tokenOffers:
              brand_data.plugins.tokenOffers === undefined
                ? true
                : brand_data.plugins.tokenOffers,
            discountOffers:
              brand_data.plugins.discountOffers === undefined
                ? false
                : brand_data.plugins.discountOffers,
            earnTokens:
              brand_data.plugins.earnTokens === undefined
                ? true
                : brand_data.plugins.earnTokens,
            shop:
              brand_data.plugins.shop === undefined
                ? true
                : brand_data.plugins.shop,
            saving:
              brand_data.plugins.saving === undefined
                ? true
                : brand_data.plugins.saving,
            myId:
              brand_data.plugins.myId === undefined
                ? true
                : brand_data.plugins.myId,
            timeline:
              brand_data.plugins.timeline === undefined
                ? true
                : brand_data.plugins.timeline,
            task_subsite:
              brand_data.plugins.task_subsite === undefined
                ? true
                : brand_data.plugins.task_subsite,
            task_submission:
              brand_data.plugins.task_submission === undefined
                ? true
                : brand_data.plugins.task_submission,
          }
        : {
            explore: true,
            support: true,
            tokenPay: true,
            feeds: true,
            polls: true,
            friends: true,
            community: false,
            events: false,
            reviews: false,
            tokenwallet: true,
            cardwallet: true,
            bankwallet: true,
            ecopay: true,
            tokenOffers: true,
            discountOffers: false,
            earnTokens: true,
            shop: true,
            saving: true,
            myId: true,
            timeline: true,
            task_subsite: true,
            task_submission: true,
          },
    });
    Firebase.getAllBrands((res) => {
      let brands = res
        .map((item, index) => {
          let new_item = item;
          new_item.id = index;
          return new_item;
        })
        .filter((item) => item.name !== res.name);
      this.setState({ brands, loading: false });
    });
  };
  copyText = (url) => {
    document.getElementById("notify").click();
    navigator.clipboard.writeText(url);
    this.setState({ iframeURL: url });
  };
  handlePermissionRadioValueChanged = (name, value) => () => {
    const { brand } = this.state;
    const newPlugins = {
      ...this.state.plugins,
      [name]: value,
    };
    this.setState({ plugins: newPlugins });
    Firebase.updateBrandDataById(brand, {
      permissions: newPlugins,
    });
  };
  render() {
    const {
      username,
      role,
      logo,
      brand_name,
      brand,
      is_property_brand,
      loading,
      plugins,
      demoUser,
      iframeURL,
    } = this.state;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container">
          <div className="description-content">
            <img src={Genius} alt="genius" />
            <div className="items">
              <p>
                - Your standalone page links are prepared to allow you to iframe
                specific pages within your 3rd party app
              </p>
              <p>
                - The objective of framing standalone pages is to ensure only
                your navigation is used, with Eco navigation hidden
              </p>
              <p>
                - The api allows you to create users in the EcoiD database and
                then link their unique UID after &uid=
              </p>
              <p>
                - The api allows you to track which page a single defined user
                is presently on so you can control their journey remotely
              </p>
            </div>
          </div>
          <div className="plugins-content">
            {loading && (
              <div className="loading">
                <i className="fa fa-4x fa-sync fa-spin text-muted" />
              </div>
            )}
            {!loading && (
              <React.Fragment>
                <div className="left-content">
                  <div className="name-div">
                    <h4
                      style={{ width: 200, marginBottom: 0, textAlign: "left" }}
                    >
                      Community Apps
                    </h4>
                    <p style={{ marginBottom: 0, fontSize: 17 }}>
                      <b>Active &nbsp; or &nbsp; deactive</b>
                    </p>
                  </div>
                  {Object.keys(pagesBySection).map((section) => {
                    const { displayname } = pagesBySection[section];
                    return (
                      <div>
                        <div className="tab-title">{displayname}</div>
                        {Object.keys(pagesBySection[section].tabs).map(
                          (key) => (
                            <div className="group-input">
                              <div className="group-label">
                                <img
                                  src={images[key]}
                                  className="community-tab-icon"
                                ></img>
                                {titles[key]}
                              </div>
                              <div className="radio-container">
                                <input
                                  type="radio"
                                  id={`${key}_yes`}
                                  checked={plugins[key]}
                                  onClick={this.handlePermissionRadioValueChanged(
                                    key,
                                    true
                                  )}
                                />
                                <label htmlFor={`${key}_yes`}>Yes</label>
                                <input
                                  type="radio"
                                  id={`${key}_no`}
                                  checked={!plugins[key]}
                                  onClick={this.handlePermissionRadioValueChanged(
                                    key,
                                    false
                                  )}
                                />
                                <label htmlFor={`${key}_no`}>No</label>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    );
                  })}
                </div>
                <div className="middle-content">
                  <div className="name-div">
                    <p>Demo user iframe link</p>
                  </div>
                  {Object.keys(pagesBySection).map((section) => (
                    <div>
                      <div className="tab-title" />
                      {Object.keys(pagesBySection[section].tabs).map((key) => {
                        return (
                          <div className="group-input">
                            <div
                              className={`hyperlink-div ${
                                plugins[key] ? "yes" : "no"
                              }`}
                            >
                              {demoUser && (
                                <p
                                  className="right-text"
                                  onClick={
                                    plugins[key]
                                      ? () =>
                                          this.copyText(
                                            `https://ecosystem.life/${brand_name.replace(
                                              /\s/g,
                                              ""
                                            )}?page=${
                                              pagesBySection[section].tabs[key]
                                                .id
                                            }&uid=${demoUser.id}`
                                          )
                                      : () => {}
                                  }
                                >
                                  https://ecosystem.life/
                                  {brand_name.replace(/\s/g, "")}?page=
                                  {pagesBySection[section].tabs[key].id}&uid=
                                  {demoUser.id}{" "}
                                </p>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ))}
                </div>
                <div className="right-content">
                  {iframeURL && (
                    <div className="iphone-screenshot">
                      <img
                        src={iPhoneBorder}
                        className="iphone-border"
                        alt="iphone-border"
                      />
                      <iframe
                        src={iframeURL}
                        title={`iFrame of ${
                          demoUser.firstname
                        } on ${brand_name.replace(/\s/g, "")}`}
                        className="iphone-iframe"
                      />
                      <p className="iphone-link">{iframeURL}</p>
                    </div>
                  )}
                </div>
              </React.Fragment>
            )}
          </div>
        </main>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    brand: state.brand,
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(Plugins));



// WEBPACK FOOTER //
// ./src/screens/DeveloperIntegration/Plugins/index.js